import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates";

import { tagsCrudConfig } from "../consts";
import Category from "./Category";
import Tag from "./Tag";

type TagsType = Map<string, Tag>;
type CategoriesType = Map<string, Category>;

export type TagsFeatureType = {
  tags: TagsType;
  categories: CategoriesType;
  meta: CrudBuilderState | Map<any, any>;
};

export type OptionalTagsFeatureType = Partial<TagsFeatureType>;

const defaultTagsFeature: TagsFeatureType = {
  tags: Map<string, Tag>(),
  categories: Map<string, Category>(),
  meta: makeCrudBuilderInitialState(tagsCrudConfig)
};

export default class TagsFeature extends Record(defaultTagsFeature) {}
